export default class Shape {
    constructor() {
        this.footer();
    }

    footer() {
        if (document.querySelector('footer .shape')) {
            const footer = document.querySelector('footer');
            const shape = document.querySelector('footer .shape')
            const lastItem = document.querySelector('section.last-item');
            const paddingBottom = parseFloat(window.getComputedStyle(lastItem, null).getPropertyValue('padding-bottom'));
            const logo = footer.querySelector('.logo');

            if (!shape || !lastItem) return;

            setStyle();

            window.onresize = setStyle;

            function setStyle() {
                const height = shape.clientHeight - 1;
                const padding = paddingBottom + height;
                const margin = height - (height / 2);

                logo.style.marginTop = '-' + margin + 'px';
                lastItem.style.paddingBottom = padding + 'px';
                shape.style.top = '-' + height + 'px';
            }
        }
    }
}
